import { render, staticRenderFns } from "./viewDataInfo.vue?vue&type=template&id=1a26ee21"
import script from "./viewDataInfo.vue?vue&type=script&lang=js"
export * from "./viewDataInfo.vue?vue&type=script&lang=js"
import style0 from "./viewDataInfo.vue?vue&type=style&index=0&id=1a26ee21&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports